// extracted by mini-css-extract-plugin
module.exports = {"date":"event-date-module--date--1dkyM"};